module.exports = __webpack_public_path__ + "img/logo_davidoff@3x.4e1a9fde.png";